import * as React from 'react';
const { connect } = require('react-redux');
import { translate } from 'react-i18next';
import { PortalPageSection } from 'components/PortalStructure';
import { PortalSelectMenu } from 'components/FormControls';
import { IPortalPageSection } from 'models/portal/page/portalpagesection';
import * as c from 'models/constants';
import { IModalAction } from 'models/modal';
import { Modal } from 'components';
import { reduxForm, change, Field, FormProps } from 'redux-form';
import { Button, ErrorSummary } from 'components';
import { ButtonsSection } from 'components/PortalStructure';
import { Tabs, TabLink, TabContent } from 'react-tabs-redux';
import { required } from 'helpers/validationattributes';
import { IStore } from 'redux/IStore';
import { getCategoryDomainValues } from 'redux/modules/domainvalues';
import { ICategoryDomainValue } from 'models/common';
require('components/Tabs/style.css');

type dropdownCategoryKeyObject = {
	0?: number;
	1?: number;
	2?: number;
	3?: number;
	4?: number;
	5?: number;
};

interface IState {
	error: boolean;
	message: any;
	firstDropdownCategoryKey: dropdownCategoryKeyObject;
	secondDropdownCategoryKey: dropdownCategoryKeyObject;
	thirdDropdownCategoryKey: dropdownCategoryKeyObject;
	fourthDropdownCategoryKey: dropdownCategoryKeyObject;
}

interface IProps {
	section: IPortalPageSection;
	showHeaderCloseButton: boolean;
	currentForm: FormProps;
	index: number;
	baseUrlClient?: string;
	categoryDomainValues?: ICategoryDomainValue[];

	/* form props */
	pristine: boolean;
	dirty: boolean;
	submitting: boolean;
	handleSubmit: any;
	submitFailed: boolean;
	formErrors?: any;

	/* function props */
	closeModal?: () => IModalAction;
	t?: (key: string) => string;
	change?: (field: any, value: any) => void;
	saveSection?: (form: IPortalPageSection, index?: number) => void;
	getCategoryDomainValues?: () => void;
}

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class EditSectionType11Form extends React.Component<IProps, IState> {
	constructor(props) {
		super(props);

		this.state = {
			error: false,
			message: null,
			firstDropdownCategoryKey: {},
			secondDropdownCategoryKey: {},
			thirdDropdownCategoryKey: {},
			fourthDropdownCategoryKey: {},
		};

		this.onSubmit = this.onSubmit.bind(this);
		this.setError = this.setError.bind(this);
		this.clearError = this.clearError.bind(this);
		this.getBoxContent = this.getBoxContent.bind(this);
		this.clearFormValues = this.clearFormValues.bind(this);
		this.setViewLayerData = this.setViewLayerData.bind(this);
		this.getCategoryName = this.getCategoryName.bind(this);

		this.onFirstCategoryDropdownChange = this.onFirstCategoryDropdownChange.bind(this);
		this.onSecondCategoryDropdownChange = this.onSecondCategoryDropdownChange.bind(this);
		this.onThirdCategoryDropdownChange = this.onThirdCategoryDropdownChange.bind(this);
		this.onFourthCategoryDropdownChange = this.onFourthCategoryDropdownChange.bind(this);
	}

	public UNSAFE_componentWillMount() {
		this.props.getCategoryDomainValues();
	}

	private setError(error: any) {
		this.setState({
			error: true,
			message: error,
		});
	}

	private clearError() {
		this.setState({
			error: false,
			message: null,
		});
	}

	private clearFormValues() {
		const items = [
			{
				elements: [
					{
						text: null,
						redirectUrl: null,
					},
				],
			},
		];

		this.props.change('items', items);
	}

	private onSubmit(form: IPortalPageSection) {
		this.props.saveSection(form, this.props.index);
	}

	private getCategoryName(categoryKey: number): string {
		return this.props.categoryDomainValues.find((x) => x.key === categoryKey).value;
	}
	private setViewLayerData(index: number, key: number) {
		this.props.change('items[' + index + '].elements[1].categoryName', this.getCategoryName(key));
		this.props.change('items[' + index + '].elements[1].redirectUrl', `${this.props.baseUrlClient}/search?cat=${key}`);
	}
	////////////////////////////////////////////////////////////////////
	// Selection handling
	////////////////////////////////////////////////////////////////////
	public onFirstCategoryDropdownChange(key: number, index: number) {
		this.props.change('items[' + index + '].elements[0].text0', key);
		this.setViewLayerData(index, key);
		this.setState({
			firstDropdownCategoryKey: {
				...this.state.firstDropdownCategoryKey,
				[index]: key,
			},
			secondDropdownCategoryKey: {
				...this.state.secondDropdownCategoryKey,
				[index]: null,
			},
			thirdDropdownCategoryKey: {
				...this.state.thirdDropdownCategoryKey,
				[index]: null,
			},
			fourthDropdownCategoryKey: {
				...this.state.fourthDropdownCategoryKey,
				[index]: null,
			},
		});
	}

	public onSecondCategoryDropdownChange(key: number, index: number) {
		this.props.change('items[' + index + '].elements[0].text1', key);
		this.setViewLayerData(index, key);
		this.setState({
			secondDropdownCategoryKey: {
				...this.state.secondDropdownCategoryKey,
				[index]: key,
			},
			thirdDropdownCategoryKey: {
				...this.state.thirdDropdownCategoryKey,
				[index]: null,
			},
			fourthDropdownCategoryKey: {
				...this.state.fourthDropdownCategoryKey,
				[index]: null,
			},
		});
	}

	public onThirdCategoryDropdownChange(key: number, index: number) {
		this.props.change('items[' + index + '].elements[0].text2', key);
		this.setViewLayerData(index, key);
		this.setState({
			thirdDropdownCategoryKey: {
				...this.state.thirdDropdownCategoryKey,
				[index]: key,
			},
			fourthDropdownCategoryKey: {
				...this.state.fourthDropdownCategoryKey,
				[index]: null,
			},
		});
	}

	public onFourthCategoryDropdownChange(key: number, index: number) {
		this.props.change('items[' + index + '].elements[0].text3', key);
		this.setViewLayerData(index, key);
		this.setState({
			fourthDropdownCategoryKey: {
				...this.state.fourthDropdownCategoryKey,
				[index]: key,
			},
		});
	}
	////////////////////////////////////////////////////////////////////

	private getBoxContent(index) {
		const { t, categoryDomainValues } = this.props;
		const { firstDropdownCategoryKey, secondDropdownCategoryKey, thirdDropdownCategoryKey } = this.state;

		////////////////////////////////////////////////////////////////////
		// Extract values from initialized form
		////////////////////////////////////////////////////////////////////
		const getFirstCategoryFormValue = () => {
			if (
				this.props.currentForm?.values?.items.length &&
				this.props.currentForm?.values?.items[index] &&
				this.props.currentForm?.values['items'][index]['elements'][0]['text0']
			) {
				return this.props.currentForm?.values['items'][index]['elements'][0]['text0'];
			}
		};
		const getSecondCategoryFormValue = () => {
			if (
				this.props.currentForm?.values?.items.length &&
				this.props.currentForm?.values?.items[index] &&
				this.props.currentForm?.values['items'][index]['elements'][0]['text1']
			) {
				return this.props.currentForm?.values['items'][index]['elements'][0]['text1'];
			}
		};
		const getThirdCategoryFormValue = () => {
			if (
				this.props.currentForm?.values?.items.length &&
				this.props.currentForm?.values?.items[index] &&
				this.props.currentForm?.values['items'][index]['elements'][0]['text2']
			) {
				return this.props.currentForm?.values['items'][index]['elements'][0]['text2'];
			}
		};
		const getFourthCategoryFormValue = () => {
			if (
				this.props.currentForm?.values?.items.length &&
				this.props.currentForm?.values?.items[index] &&
				this.props.currentForm?.values['items'][index]['elements'][0]['text3']
			) {
				return this.props.currentForm?.values['items'][index]['elements'][0]['text3'];
			}
		};
		////////////////////////////////////////////////////////////////////
		// Category items setting
		////////////////////////////////////////////////////////////////////
		let firstDropdownCategories = [];
		let secondDropdownCategories = [];
		let thirdDropdownCategories = [];
		let fourthDropdownCategories = [];
		if (categoryDomainValues) {
			firstDropdownCategories = categoryDomainValues
				.filter((x) => !x.parentKey)
				.map((category: ICategoryDomainValue) => {
					return {
						key: category.key,
						value: t(`DV_Categories_${category.key}`),
					};
				});

			if (this.state.firstDropdownCategoryKey || getFirstCategoryFormValue()) {
				secondDropdownCategories = categoryDomainValues
					.filter(
						(x) =>
							x.parentKey === this.state.firstDropdownCategoryKey[index] || x.parentKey === getFirstCategoryFormValue(),
					)
					.map((category: ICategoryDomainValue) => {
						return {
							key: category.key,
							value: t(`DV_Categories_${category.key}`),
						};
					});
			}

			if (this.state.secondDropdownCategoryKey || getSecondCategoryFormValue()) {
				thirdDropdownCategories = categoryDomainValues
					.filter(
						(x) =>
							x.parentKey === this.state.secondDropdownCategoryKey[index] ||
							x.parentKey === getSecondCategoryFormValue(),
					)
					.map((category: ICategoryDomainValue) => {
						return {
							key: category.key,
							value: t(`DV_Categories_${category.key}`),
						};
					});
			}

			if (this.state.thirdDropdownCategoryKey || getThirdCategoryFormValue()) {
				fourthDropdownCategories = categoryDomainValues
					.filter(
						(x) =>
							x.parentKey === this.state.thirdDropdownCategoryKey[index] || x.parentKey === getThirdCategoryFormValue(),
					)
					.map((category: ICategoryDomainValue) => {
						return {
							key: category.key,
							value: t(`DV_Categories_${category.key}`),
						};
					});
			}
		}

		return (
			<PortalPageSection usage="admin">
				<div className="row">
					<div className="col-md-12">
						<Field
							name={'items[' + index + '].elements[0].text0'}
							component={PortalSelectMenu}
							input={{
								id: 'firstCategoryDropdown',
								onChange: (value) => this.onFirstCategoryDropdownChange(value, index),
								value: this.state.firstDropdownCategoryKey[index] || getFirstCategoryFormValue(),
								name: 'firstCategoryDropdown',
							}}
							items={firstDropdownCategories}
							label={t('PortalPage_Section_Manage_DropdownLabel_CategoryLevel') + ' 0'}
							validate={[required]}
							isRequired={true}
						/>
					</div>
				</div>

				{(firstDropdownCategoryKey[index] || getFirstCategoryFormValue()) && secondDropdownCategories.length > 0 ? (
					<div className="row">
						<div className="col-md-12">
							<Field
								name={'items[' + index + '].elements[0].text1'}
								component={PortalSelectMenu}
								input={{
									id: 'secondCategoryDropdown',
									onChange: (value) => this.onSecondCategoryDropdownChange(value, index),
									value: this.state.secondDropdownCategoryKey[index] || getSecondCategoryFormValue(),
									name: 'secondCategoryDropdown',
								}}
								items={secondDropdownCategories}
								label={t('PortalPage_Section_Manage_DropdownLabel_CategoryLevel') + ' 1'}
							/>
						</div>
					</div>
				) : null}

				{(secondDropdownCategoryKey[index] || getSecondCategoryFormValue()) && thirdDropdownCategories.length > 0 ? (
					<div className="row">
						<div className="col-md-12">
							<Field
								name={'items[' + index + '].elements[0].text2'}
								component={PortalSelectMenu}
								input={{
									id: 'thirdCategoryDropdown',
									onChange: (value) => this.onThirdCategoryDropdownChange(value, index),
									value: this.state.thirdDropdownCategoryKey[index] || getThirdCategoryFormValue(),
									name: 'thirdCategoryDropdown',
								}}
								items={thirdDropdownCategories}
								label={t('PortalPage_Section_Manage_DropdownLabel_CategoryLevel') + ' 2'}
							/>
						</div>
					</div>
				) : null}

				{(thirdDropdownCategoryKey[index] || getThirdCategoryFormValue()) && fourthDropdownCategories.length > 0 ? (
					<div className="row">
						<div className="col-md-12">
							<Field
								name={'items[' + index + '].elements[0].text3'}
								component={PortalSelectMenu}
								input={{
									id: 'fourthCategoryDropdown',
									onChange: (value) => this.onFourthCategoryDropdownChange(value, index),
									value: this.state.fourthDropdownCategoryKey[index] || getFourthCategoryFormValue(),
									name: 'fourthCategoryDropdown',
								}}
								items={fourthDropdownCategories}
								label={t('PortalPage_Section_Manage_DropdownLabel_CategoryLevel') + ' 3'}
							/>
						</div>
					</div>
				) : null}
			</PortalPageSection>
		);
	}

	public render() {
		const { error, message } = this.state;
		const { pristine, submitting, handleSubmit, t, showHeaderCloseButton, closeModal, currentForm } = this.props;

		const errorSummaryProps = {
			error,
			message,
		};

		let content: JSX.Element = null;

		const tabs = [];
		const tabsContents = [];
		const tabHasErrors = (tabIndex: number): boolean => {
			if (currentForm?.syncErrors?.items[tabIndex] && currentForm?.submitFailed) {
				return true;
			} else {
				return false;
			}
		};
		for (let i: number = 0; i < 6; i++) {
			tabs.push(
				<TabLink key={i} className={`tab ${tabHasErrors(i) ? 'error' : ''}`} to={`box${i + 1}`}>
					<span>{t('Magazine_Section_Manage_Common_Label_Box') + (i + 1)}</span>
				</TabLink>,
			);
			const tabContent = this.getBoxContent(i);
			tabsContents.push(
				<TabContent key={i} for={`box${i + 1}`}>
					{tabContent}
				</TabContent>,
			);
		}

		content = (
			<Tabs name="sectionItemSelectorTabs" tabComponent="div">
				<div className="tabsHolder">{tabs}</div>
				<div className="tabsContent">{tabsContents}</div>
			</Tabs>
		);

		return (
			<Modal
				title={
					t('PortalPage_Section_Manage_Common_EditSection') +
					' - ' +
					t('PortalPage_Section_Manage_SectionTitle_ShopByCategory')
				}
				showHeaderCloseButton={showHeaderCloseButton}
				closeModal={closeModal}
				modalClass="portalPageSectionManageWrapper"
				size="normal"
			>
				<div>
					<div>
						<ErrorSummary {...errorSummaryProps} />
					</div>
					<form onSubmit={handleSubmit(this.onSubmit)}>
						<div>
							{content}
							<ButtonsSection>
								<div className="row">
									<div className="col-sm-12">
										<Button type="submit" usage="admin" disabled={pristine || submitting}>
											{t('BSPortal_Common_SaveAndClose')}
										</Button>
									</div>
								</div>
							</ButtonsSection>
						</div>
					</form>
				</div>
			</Modal>
		);
	}
}

function mapStateToProps(state: IStore, ownProps: IProps) {
	const newProps = {
		type: c.PORTAL_PAGE_SECTION_TYPE_11,
		items: [],
	};

	let currentForm: FormProps = null;
	if (state.form[c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION11] && state.form[c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION11].values) {
		currentForm = state.form[c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION11];
	}

	return {
		initialValues: ownProps.section || newProps,
		currentForm,
		baseUrlClient: state.fetchDefault?.baseUrlClient,
		categoryDomainValues: state.domainValues.categories,
	};
}

let ManageType11 = reduxForm(
	{
		form: c.FORM_NAME_EDIT_PORTAL_PAGE_SECTION11,
		enableReinitialize: true,
	},
	mapStateToProps,
)(EditSectionType11Form);

ManageType11 = connect(mapStateToProps, (dispatch) => ({
	dispatch,
	change: (field: string, value: string) => dispatch(change(field, value)),
	getCategoryDomainValues: () => dispatch(getCategoryDomainValues()),
}))(ManageType11);

export { ManageType11 };
